module.exports = __webpack_public_path__ + "img/paypal.685da7b0.png";